import React, { useEffect, useState } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Spinner, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { FormControlLabel, Checkbox } from "@mui/material";
import Select from "react-select";
import ApiSupplierAgentCommission from "../../../core/api/api.supplierAgentCommission";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiAgent from "../../../core/api/api.agent";
import Swal from "sweetalert2";


export const AssignCommissionGroupToSupplier = ({
  setShowAddCommissionToAgentModal,
  selectedSupplierAgentCommissionId,
  supplierList
}) => {
  let handleClose = () => {
    setShowAddCommissionToAgentModal(false);
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    defaultValues: { isActive: true },
  });
  const [agentCommissionList, setAgentCommissionList] = useState();
  const [agentList, setAgentList] = useState();

  useEffect(() => {
    (async () => {
      try {
        const agentList = await ApiAgent.getAllAgentsName();
        setAgentList(agentList.filter(agent => agent.isActive == true));
        if (selectedSupplierAgentCommissionId != 0) {
          const response =
            await ApiSupplierAgentCommission.getSupplierAgentCommissionById({
              id: selectedSupplierAgentCommissionId,
            });
          if (response.succeeded) {
            const data = response.data;
            if (data.agentCommissionId) {
              setValue("agentCommissionId", {
                label: data.agentCommissionName,
                value: data.agentCommissionId,
              });
            }
            if (data.supplierId) {
              setValue("supplierId", {
                label: data.supplierCompanyName,
                value: data.supplierId,
              });
              handleSupplierChange(data.supplierId);
            }
            if (data.agentId) {
              setValue("agentIds", {
                label: data.agentCompanyName,
                value: data.agentId,
              });
            }
            setValue("isActive", data.isActive);
          }
        }

      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);
  const handleSupplierChange = async (supplierId) => {
    const agentCommissions = await ApiAgentCommission.getAllAgentCommissionsBySupplierId({ supplierId });
    setAgentCommissionList(agentCommissions.data.filter(item => item.isActive));
  }
  const onSubmit = async (data) => {
    try {
      const input = {
        id: selectedSupplierAgentCommissionId,
        supplierId: data.supplierId?.value,
        commissionId: data.agentCommissionId?.value,
        agentIds: Array.isArray(data.agentIds)
          ? data.agentIds.map(a => a.value)
          : [data.agentIds?.value],
        isActive: data.isActive
      }
      const response = await ApiSupplierAgentCommission.createOrEditSupplierAgentCommissionCommand(input);
      if (response && response.data.length > 0 && selectedSupplierAgentCommissionId == 0) {
        // ساخت و نمایش پیغام خروجی
        let HtmlOutPut = response.data
          .map((item) => {
            return (
              "<div class='border rounded-3 text-end py-2 px-4 mb-5 " +
              (item.status == true
                ? "bg-light-success border-light-success text-dark-success-msg-box"
                : "bg-light-danger border-light-danger text-dark-danger-msg-box") +
              "'>" +
              " <div> " +
              item.message +
              "</div></div>"
            );
          })
          .join("");
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success  mr-2 px-5 ",
            cancelButton: "btn btn-danger px-5 ",
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons.fire({
          title: " تخصیص گروه کمیسیون به نمایندگان",
          icon: "info",
          html: HtmlOutPut,
          type: "success",
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: "  بستن ",
        });

        // ویرایش دیتا های روی صفحه پشتی
        //props.data.callBack();



      }
      // else if(selectedSupplierAgentCommissionId==0)
      //   SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      else
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      // بستن مدال
      handleClose();
      document.getElementById("submitButton").click();
    }
    catch (error) {

    }
  };
  return (
    <div>
      <Modal centered size="md" show={true} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{`${selectedSupplierAgentCommissionId === 0 ? "تخصیص گروه کمیسیون به نمایندگان" : "ویرایش تخصیص گروه کمیسیون به نمایندگان"}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="supplierId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      className="mt-5"
                      options={supplierList?.map((item) => ({
                        value: item.id,
                        label: item.companyName,
                      }))}
                      placeholder="تامین کننده"
                      field={field}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption); // مقدار فیلد در فرم آپدیت می‌شود
                        handleSupplierChange(selectedOption?.value);
                        setValue('agentCommissionId', "");
                      }}
                    />
                  )}
                />
                {errors.supplierId && (
                  <span className="text-danger text-right">
                    تامین کننده را وارد نمایید{" "}
                  </span>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Controller
                  name="agentCommissionId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      className="mt-5"
                      placeholder=" گروه کمیسیون"
                      options={agentCommissionList?.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      field={field}
                    />
                  )}
                />
                {errors.agentCommissionId && (
                  <span className="text-danger text-right">
                    گروه کمیسیون را وارد نمایید{" "}
                  </span>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Controller
                  name="agentIds"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      className="mt-5"
                      placeholder=" نماینده"
                      options={agentList?.map((item) => ({
                        value: item.id,
                        label: item.companyName,
                      }))}
                      field={field}
                      isMulti={selectedSupplierAgentCommissionId == 0 ? true : false}
                    />
                  )}
                />
                {errors.agentIds && (
                  <span className="text-danger text-right">
                    نماینده را وارد نمایید{" "}
                  </span>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"isActive"}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Checkbox
                          color="primary"
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value || false}
                          inputRef={ref}
                        />
                      )}
                    />
                  }
                  label="فعال"
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
